import {
  Chip,
  ListItem,
  Checkbox,
  TextField,
  Autocomplete,
  ListItemIcon,
  ListItemText,
  CircularProgress,
  type AutocompleteInputChangeReason
} from "@material-ui/core";
import type { SyntheticEvent } from "react";

type AutocompleteMultiSelectProps = {
  label?: string;
  value: string[];
  small?: boolean;
  options: string[];
  loading?: boolean;
  emptyLabel?: string;
  onChange: (value: string[]) => void;
  onInputChange?: (
    _event: SyntheticEvent,
    newInputValue: string,
    reason: AutocompleteInputChangeReason
  ) => void;
  getOptionLabel?: (option: string) => string;
};

export function AutocompleteMultiSelect({
  label,
  value,
  small,
  options,
  loading,
  emptyLabel,
  onChange,
  onInputChange,
  getOptionLabel
}: AutocompleteMultiSelectProps) {
  const handleChange = (_event: SyntheticEvent, newValue: string[]): void => {
    onChange(newValue);
  };

  const useEmptyLabel = value.length === 0 && emptyLabel;

  if (useEmptyLabel) {
    label = emptyLabel;
  }

  return (
    <Autocomplete
      multiple
      fullWidth
      disableCloseOnSelect
      size={small ? "small" : "medium"}
      value={value}
      options={options}
      loading={loading}
      ListboxProps={{
        style: {
          maxHeight: 410
        }
      }}
      onChange={handleChange}
      onInputChange={onInputChange}
      getOptionLabel={getOptionLabel}
      renderTags={(selectedValue, getTagProps) =>
        selectedValue.map((option, index) => (
          <Chip
            label={getOptionLabel ? getOptionLabel(option) : option}
            size="small"
            color="primary"
            {...getTagProps({ index })}
            key={option}
          />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          InputProps={{
            ...params.InputProps,
            endAdornment: loading && <CircularProgress size={20} />
          }}
        />
      )}
      renderOption={(props, option, { selected }) => (
        <ListItem {...props} key={option}>
          <ListItemIcon>
            <Checkbox edge="start" checked={selected} tabIndex={-1} disableRipple />
          </ListItemIcon>
          <ListItemText primary={getOptionLabel ? getOptionLabel(option) : option} />
        </ListItem>
      )}
    />
  );
}
